import { object, string } from '~utils/validation';

export default object({
  token: string().required(),
});
